export interface IImmunofreeCandidate {
    id: number,
    recipientId: number,
    email: string,
    firstName: string,
    lastName: string,
    dateOfBirth: string,
    transplantDate: string,
    alleleMatch: string
}